import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../../modules/utility';

const apiBase = 'ticketCategory';
const listName = `ticketCategories`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;
const item = 'ticket category';
const onSuccessRedirectTo = `/ticketCategory/list`;

const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : idsField,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage : `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay:350,
			callback,
		});
	};
};

const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage : `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay:350,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const newState = {};

	const userId = (ownProps[idField])
		? ownProps[idField]
		: _.get(ownProps, ['match', 'params', idField]);

	newState[apiBase] = _.get(state.maps, [apiBase, userId]);

	newState[listName] = [];
	if (state.lists[idsField]) {
		newState[listName] = _.map(state.lists[idsField], id => state.maps[apiBase][id]);
	}

	/** @namespace state.maps.ticketSchema */
	newState.ticketSchemaMap = state.maps.ticketSchema;
	newState.userMap = state.maps.user;
	return newState;
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getTicketCategory : get,
	addTicketCategory : add,
	updateTicketCategory : update,
	searchTicketCategories : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);